import React from "react";
import style from "./Pillars.module.css";
import PillarsCard from "../../components/PillarsCard";
import {NuFolks, HumanAI, InterviewPanel, Linkedin, ShineBright, Extra} from "../../assets";   

function Pillars() {

    const pillarValues = [
        {
            icon: NuFolks,
            heading: "NuFolks runs on tech",
            content: " Our cutting-edge technological platform leverages advanced AI to revolutionize candidate screening, utilizing predictive analytics and real-time skills matching to transform recruitment into a precise, data-driven process."
        },
        {
            icon: HumanAI,
            heading: "Humans & AI Filtering Together", 
            content: "Together We blend empathetic artificial intelligence with human expertise, implementing bias-reduction algorithms to create a personalized, nuanced candidate experience that balances technological efficiency with human insight."
        },
        {
            icon: InterviewPanel,
            heading: "900+ Interviewers Panel",
            content: "Our expansive network of expert interviewers provides comprehensive, industry-specific evaluation frameworks, continuously trained to ensure rigorous, diverse, and high-quality candidate assessment."
        },
        {
            icon: Linkedin,
            heading: "LinkedIn Hiring Automation",
            content: " Utilizing intelligent sourcing technologies, we streamline talent pipeline management through seamless workflow integration, transforming LinkedIn's professional network into a strategic recruitment ecosystem."
        },
        {
            icon: ShineBright,
            heading: "Our Recruiters Shine Bright.",
            content: " Our recruiters bring specialized industry expertise, adopting a consultative talent acquisition approach and pursuing continuous professional development to deliver exceptional, tailored recruitment solutions."
        },
        {
            icon: Extra,
            heading: "Strategic Talent Optimization",
            content: " We approach workforce planning holistically, mapping career trajectories and identifying skills gaps to create comprehensive talent strategies that align individual potential with organizational objectives."
        }
    ]

    return(

        <div className={style.Pillars_outerBorder}>
            <div className={style.Pillars_container} data-aos="fade-up" data-aos-duration="1200" data-aos-offset="20">
                <div className={style.Pillars_heading}>
                    <p>The Pillars That Drive<br className={style.removeBreak} />Us Forward</p>
                    <p>Fueling Growth with Innovation & Expertise —Empowering organizations with top-tier talent and tailored staffing solutions.</p>
                </div>
                <div className={style.PillarsCards_container}>
                    <PillarsCard data={pillarValues[0]} />
                    <PillarsCard data={pillarValues[1]} />
                    <PillarsCard data={pillarValues[2]} />
                    <PillarsCard data={pillarValues[3]} />
                    <PillarsCard data={pillarValues[4]} />
                    <PillarsCard data={pillarValues[5]} />
                </div>
            </div>
        </div>
    );
}

export default Pillars;